module.exports = __webpack_public_path__ + "static/forbesLogo-bd514687f1af6dbb41eb072bd5c78607.png";